import FormInterest from "./FormInterest";

export default FormInterest;